// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1wlNo","approved":"Status_approved__3vwGm","rejected":"Status_rejected__2h3jj","expired":"Status_expired__1TpNY","label":"Status_label__1b0WD"};